import React, { useState } from "react";

//Styles
import "./ByIndustry.scss";

//Data
import { logoIndustriesExampleData } from "./exampleData";

function ByIndustry() {
  const [moreVisible, setMoreVisible] = useState(false);
  return (
    <section className="page-landing by-industy">
      <h3 className="m-width-wrapper">Custom logo design by industry</h3>
      <ul className={"m-width-wrapper" + (moreVisible ? " more-visible" : "")}>
        {logoIndustriesExampleData.map((industry, index) =>
          index > 4 ? (
            <li className="when-more" key={index}>
              {industry}
            </li>
          ) : (
            <li key={index}>{industry}</li>
          )
        )}
        <button
          className="more-btn"
          onClick={() => {
            setMoreVisible(!moreVisible);
          }}
        >
          {moreVisible ? "less..." : "more..."}
        </button>
      </ul>
    </section>
  );
}

export default ByIndustry;
